import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getLogo, getCondition, getSiteName, getStyles } from '../services/Firebase'; //getPageStyles
import LanguageSelector from '../components/LanguageSelector';
const _ = require('lodash');

// @src/pages/Condition.jsx
const Condition = () => {
    const { lang } = useParams();
    const [lng, setLng] = useState(lang || 'es');
    const [datas, setDatas] = useState({});
    const [img, setImg] = useState();
    const [name, setName] = useState('IguanaGIFT');
    const [styles, setStyles] = useState({}); // para guardar estilos dinamicos recuperamos de Firestore
    const styleRef = useRef(null);

    // util: camelCase -> kebab-case
    const camelToKebab = (str) => str.replace(/[A-Z]/g, (m) => "-" + m.toLowerCase());

    // util: { fontSize: "20px", color: "#333" } -> "font-size:20px; color:#333;"
    const objectToCss = (obj, useImportant = false) =>
        obj
            ? Object.entries(obj)
                .map(([k, v]) => `${camelToKebab(k)}:${String(v)}${useImportant ? " !important" : ""};`)
                .join(" ")
            : "";

    useEffect(() => {
        async function initData() {
            setImg(await getLogo());
            setName(await getSiteName());
            setStyles(await getStyles());
            // setStyles(await getPageStyles("condition-styles", "default")); // si tuvieramos estilos para cada plantilla 
        };
        initData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getData(lng);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lng]);

    const getData = async (lng) => {
        const ouch = _.cloneDeep(datas);
        if (ouch[lng] == null || ouch[lng].length <= 0) {
            const policy = await getCondition(lng);
            ouch[lng] = policy;
            setDatas(ouch);
        }
    }

    // Inyecta CSS scoped (incluye regla para .texts y que ademas aplique a los hijos p)
    useEffect(() => {
        const scope = '[data-scope="condition"]';
        const clsList = Object.keys(styles || {});

        const parts = clsList.map((cls) => {
            const rules = objectToCss(styles[cls], true);
            if (!rules) return "";
            if (cls === "texts") {
                // aplica al contenedor .texts y también a los p dentro si no tienen class propia
                return `${scope} .${cls}, ${scope} .${cls} p { ${rules} }`;
            }
            return `${scope} .${cls} { ${rules} }`;
        }).filter(Boolean);

        if (!styleRef.current) {
            const tag = document.createElement("style");
            tag.setAttribute("data-owner", "dynamic-styles-from-fb"); //"dynamic-styles-from-fb" es un tag random
            document.head.appendChild(tag);
            styleRef.current = tag;
        }
        styleRef.current.textContent = parts.join("\n");

        return () => {
            if (styleRef.current) {
                document.head.removeChild(styleRef.current);
                styleRef.current = null;
            }
        };
    }, [styles]);

    // estilos por defecto (por si no están definidos en Firestore)
    const containerStyle = styles?.container ?? { width: "100%" };
    const innerStyle = styles?.inner ?? { maxWidth: "700px", margin: "0 auto" };
    const logoWrapperStyle = styles?.logoWrapper ?? { textAlign: "center", paddingTop: "10px", paddingBottom: "10px" };
    const logoImgStyle = styles?.logoImg ?? { maxHeight: "200px" };

    // unimos las líneas en un único HTML string para el dangerously
    const contentHtml = datas[lng]
        ? datas[lng].lines.map((line) => line.replace(/#SITENAME#/g, name)).join('')
        : '';

    return (
        <div style={containerStyle}>
            <div style={innerStyle} data-scope="condition">
                <LanguageSelector onLanguageChange={setLng} lang={lng} />
                <div style={logoWrapperStyle}>
                    <img src={img} alt="Iguana GIFT" style={logoImgStyle} />
                </div>
                {/* Un único dangerously con todo el contenido y no un div por cada linea*/}
                <div className="dynamic-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />
            </div>
        </div>
    );
};
export default Condition;


// Una aclaracion de todos los cambios para dinamizar las clases de las plantillas
// La linea origanl: 
// {datas[lng] && datas[lng].lines.map((element, index) => (
//   <div key={index} dangerouslySetInnerHTML={{ __html: element }} />
// ))}
// Creaba un <div> wrapper por cada entrada del array. Si mi array tiene la apertura de un contenedor en una entrada (<div class="texts">) y los <p> vienen en entradas siguientes, 
// al renderizar cada fragmento en su propio wrapper, el navegador no mantiene la jerarquía esperada. Es decir, los <p> terminan fuera de .texts en el DOM final — por eso .texts p no coincide.
// La prueba (de poner en firestore class="texts" directamente en el <p>) funcionaba porque el selector apuntaba al propio <p> y no depende de la jerarquía.